import { useRef, useCallback } from 'react'

interface Props {
  stop?: boolean
  onResize: (entries: ResizeObserverEntry[]) => void
}

if (typeof ResizeObserver === 'undefined') {
  global.ResizeObserver = class ResizeObserver {
    observe: () => null
    unobserve: () => null
    disconnect: () => null
    constructor() {
      this.observe = () => null
      this.unobserve = () => null
      this.disconnect = () => null
    }
  }
}

export const useResizeObserver = ({ stop, onResize }: Props) => {
  const resizeObserver = useRef<ResizeObserver>(
    !stop ? new ResizeObserver((entries: ResizeObserverEntry[]) => onResize(entries)) : null
  )

  const containerRef = useCallback(
    (container: HTMLDivElement) => {
      if (stop) return resizeObserver.current ? resizeObserver.current.disconnect() : null

      if (container !== null && resizeObserver?.current) return resizeObserver.current.observe(container)
    },
    [stop]
  )

  return { containerRef }
}
